/**
 * The type of (redux) action to reset the breakout rooms data.
 */
export const _RESET_BREAKOUT_ROOMS = '_RESET_BREAKOUT_ROOMS';
/**
 * The type of (redux) action to update the room counter locally.
 */
export const _UPDATE_ROOM_COUNTER = '_UPDATE_ROOM_COUNTER';
/**
 * The type of (redux) action to set whether a breakout room switch is in
 * progress, so spurious join/leave and password notifications can be muted.
 */
export const _SET_BREAKOUT_ROOMS_TRANSITION = '_SET_BREAKOUT_ROOMS_TRANSITION';
/**
  * The type of (redux) action to update the breakout room data.
  *
  */
export const UPDATE_BREAKOUT_ROOMS = 'UPDATE_BREAKOUT_ROOMS';
